module.exports = __webpack_public_path__ + "static/media/26UNRWA23.e251ff39.jpg";